module.exports = __webpack_public_path__ + "img/progress1.4cc48bb1.png";